module.exports = __webpack_public_path__ + "img/timewave-rvs.f20aa1b1.png";